import {texture, spine, json} from "p3";
import common from "../common";
import MenuScene from "./MenuScene";
import screenfull from 'screenfull';
import { locale, resizeLabelToFitText } from "../utils";
import settings from "../settings";
import { Skin } from "@pixi-spine/runtime-4.1";
import definitions from "../definitions";
import QuestFactory from "../game/quest/QuestFactory";
import { isMobile } from "pixi.js-legacy";

export default class SlotsScene extends MenuScene {
    constructor() {
        super("slots");

        this._numSlots = 3;
        this._slotHolder = null;
        this._slots = [];
        this._ivandoe = null;
        this._mobileIvandoeTimer = {current:0, max:5};
    }

    destroy() {
        this.removeAllTweens(true);
        super.destroy();
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        if (!common.saveData.settings.musicMute) {
            P3.audio.playMusic("music_map_loop");
        }

        const bg = new PIXI.Sprite(texture("slots_bg_1x"));
        bg.width = common.STAGE_WIDTH;
        this.addChild(bg);

        this.createTitleBanner(locale('ui_slots_title'));

        this._ivandoe = new PIXI.spine.Spine(spine("char_ivandoe"));
        this._ivandoe.skeleton.setSlotsToSetupPose();
        this._ivandoe.skeleton.setToSetupPose();
        this._ivandoe.autoUpdate = false;
        this._ivandoe.state.setAnimation(0, 'body_idle_01', true);
        this._ivandoe.scale.set(0.33);
        this._ivandoe.slot = Math.floor(Math.random() * this._numSlots);
        this.addChild(this._ivandoe);

        const skin = new Skin("ivandoe_stance_normal");
        skin.addSkin(this._ivandoe.spineData.findSkin("normal"));
        skin.addSkin(this._ivandoe.spineData.findSkin("equip_sword"));
        skin.addSkin(this._ivandoe.spineData.findSkin("outfit_standard"));
        this._ivandoe.skeleton.setSkin(skin);
        this._ivandoe.skeleton.setSlotsToSetupPose();

        this._slotHolder = new PIXI.Container();
        this.addChild(this._slotHolder);

        this._bert = new PIXI.spine.Spine(spine("char_bert"));
        this._bert.skeleton.setSlotsToSetupPose();
        this._bert.skeleton.setToSetupPose();
        this._bert.autoUpdate = false;
        this._bert.state.setAnimation(0, 'idle_00', true);
        this._bert.position.set(1050, 680);
        this._bert.scale.set(-0.5, 0.5);
        this.addChild(this._bert);

        const addStat = (image, text) => {
            const holder = new PIXI.Container();
            const icon = new PIXI.Sprite(texture(image));
            holder.addChild(icon);
            const margin = 3;
            const label = new PIXI.BitmapText(text, {
                fontName: "Alghera Pro",
                fontSize: 25,
                align: "left",
                tint: 0x000000,
                maxWidth: (this._slotHolder.width * 0.8) - icon.width - margin
            });
            label.position.set(icon.width + margin, 7);
            holder.addChild(label);

            return holder;
        }

        let slot, slotData, questsComplete;
        const margin = 30
        const totalQuests = this._getTotalNumberOfQuests();

        for (let i = 0; i < this._numSlots; i++) {
            slot = new PIXI.Sprite(texture("panel_slot"));
            slot.id = i;
            slot.x = (slot.width + margin) * i;
            this._slotHolder.addChild(slot);
            this._slots.push(slot);

            const newText = new PIXI.BitmapText(locale('ui_slots_new_quest'), {
                fontName: "Alghera Pro",
                fontSize: 32,
                align: "center",
                tint: 0xFFFFFF,
                maxWidth: 200
            });
            newText.anchor.set(0.5, 0);
            newText.position.set(slot.width/2, (slot.height/2) + 20);
            slot.addChild(newText);

            if (!common.saveData.isSlotEmpty(i)) {

                slotData = common.saveData.getSlot(i);

                slot.statsHolder = new PIXI.Sprite(texture("panel_slot_stats_bg"));
                slot.addChild(slot.statsHolder);

                let currentY = 120;
                questsComplete = 0;
                let j;
                for (j in slotData.quests) {
                    if (slotData.quests[i] == true) {
                        questsComplete ++;
                    }
                }

                const stats = [
                    ["icon_slot_quest_complete", String(questsComplete) + "/" + String(totalQuests) + " " + locale("ui_quests_title").toLowerCase()],
                    ["icon_slot_coin", String(slotData.coins)],
                    ["icon_slot_location_pin", locale(json(slotData.player.lastLocation).metadata.name)]
                ];

                let stat, separator;
                for (j = 0; j < stats.length; j++) {
                    stat = addStat(stats[j][0], stats[j][1]);
                    stat.position.set((slot.width / 2) - (stat.width / 2), currentY);
                    slot.statsHolder.addChild(stat);
                    currentY += stat.height;
                    if (j < stats.length-1) {
                        separator = new PIXI.Sprite(texture("panel_slot_divider"));
                        separator.anchor.set(0.5, 0);
                        separator.position.set(slot.width/2, currentY + 5);
                        slot.statsHolder.addChild(separator);
                        currentY = separator.y + separator.height;
                    }
                }

                slot.deleteButton = P3.Button.create(
                    texture("btn_small_out"),
                    texture("btn_small_out"),
                    texture("btn_small_out"),
                    texture("btn_icon_delete"),
                );
                slot.deleteButton.slot = slot;
                slot.deleteButton.id = i;
                slot.deleteButton.overSoundName = "sfx_btn_generic_rollover";
                slot.deleteButton.clickSoundName = "sfx_btn_generic_press_00";
                slot.deleteButton.position.set(slot.width - 20, 20);
                this.signalListeners.push(slot.deleteButton.signals.click.add(this.onDeleteButtonClick, this));
                slot.deleteButton.visible = false;
                slot.addChild(slot.deleteButton);
            }

            const title = new PIXI.Sprite(texture("panel_slot_title_bg"));
            slot.addChild(title);

            const titleText = new PIXI.BitmapText(locale('ui_slots_slot_number').toUpperCase().replace("**", String(i+1)), {
                fontName: "Alghera Pro",
                fontSize: 35,
                align: "center",
                tint: 0x000000,
                maxWidth: slot.width - 30
            });
            titleText.anchor.set(0.5, 0);
            titleText.position.set(slot.width/2, 45);
            slot.addChild(titleText);

            slot.playButton = P3.Button.create(
                texture("btn_action_large_out"),
                null,
                null,
                texture("btn_icon_large_play"));
            slot.playButton.id = i;
            slot.playButton.new = common.saveData.isSlotEmpty(i);
            slot.playButton.overSoundName = "sfx_btn_generic_rollover";
            slot.playButton.clickSoundName = "sfx_btn_generic_press_00";
            slot.playButton.position.set(slot.width/2, slot.height);
            this.signalListeners.push(slot.playButton.signals.click.add(this.onPlayButtonClick, this));
            this.signalListeners.push(slot.playButton.signals.over.add(() => {
                if (i == this._ivandoe.slot) {
                    return;
                }
                this._hideIvandoe(() => {
                    this._placeIvandoe(i);
                    P3.audio.playSound('vo_iv_hmm_0' + i);
                });
            }, this));
            slot.addChild(slot.playButton);
        }

        this._slotHolder.y = 220;
        this._slotHolder.x = (common.STAGE_WIDTH/2) - (this._slotHolder.width/2);

        for (let i = 0; i < this._slots.length; i++) {
            if (this._slots[i].deleteButton) {
                this._slots[i].deleteButton.visible = true;
                this._slots[i].addChild(this._slots[i].deleteButton);
            }
        }

        let states = new P3.ButtonStates(texture("btn_small_out"));
        states.icon = texture("btn_icon_sound_on");
        states.iconAlt = texture("btn_icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this.addChild(this._muteButton);

        this._homeButton = P3.Button.create(
            texture("btn_small_out"),
            null,
            null,
            texture("btn_icon_home")
        );
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this._homeButton.overSoundName = "sfx_btn_generic_rollover";
        this._homeButton.clickSoundName = "sfx_btn_generic_press_00";
        this.addChild(this._homeButton);

        this._placeIvandoe(this._ivandoe.slot);

        this.resize();
    }

    update() {
        super.update();

        if(this.isSceneLoaded) {
            this._ivandoe.update(window.dt);
            this._bert.update(window.dt);

            if (isMobile.any) {
                this._mobileIvandoeTimer.current += window.dt;
                if (this._mobileIvandoeTimer.current > this._mobileIvandoeTimer.max) {
                    this._hideIvandoe(() => {
                        let num = this._ivandoe.slot;
                        while (num == this._ivandoe.slot) {
                            num = Math.floor(Math.random() * this._numSlots);
                        }
                        this._placeIvandoe(num);
                        P3.audio.playSound('vo_iv_hmm_0' + num);
                    });
                    this._mobileIvandoeTimer.max = 3 + (Math.random() * 3);
                    this._mobileIvandoeTimer.current = 0;
                }
            }
        }
    }

    resize() {
        super.resize();

        if (this.isSceneLoaded) {
            this.resizeFill();
            this._muteButton.position.set(
                (common.STAGE_WIDTH + P3.View.width - this._muteButton.width) * 0.5 - this.buttonMargin.width,
                this._muteButton.height * 0.5 + this.buttonMargin.y
            );
            this._homeButton.position.set(
                (common.STAGE_WIDTH - P3.View.width + this._homeButton.width) * 0.5 + this.buttonMargin.x,
                this._homeButton.height * 0.5 + this.buttonMargin.y
            );
        }        
    }

    onHomeButtonClick() {
        this.signals.previous.dispatch();
    }

    onPlayButtonClick(button) {
        if (button.new) {
            common.saveData.createEmptySlot(button.id, true);
        }
        common.saveData.setActiveSlot(button.id);
        this.signals.next.dispatch();
    }

    onDeleteButtonClick(button) {

        const slot = button.slot;

        this._fill = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._fill.tint = 0x000000;
        this._fill.alpha = 0;
        this._fill.interactive = true;
        this.addChild(this._fill);
        this.resizeFill();

        const panel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        panel.width = 470;
        panel.height = 310;
        panel.x = (common.STAGE_WIDTH/2) - (panel.width/2);
        panel.y = common.STAGE_HEIGHT;
        this.addChild(panel);

        const title = new PIXI.BitmapText(locale('ui_splash_delete_confirm_title'), {
            fontName: "Alghera Pro",
            fontSize: 40,
            align: "center",
            tint: 0x000000
        });
        title.anchor.set(0.5);
        title.position.set(panel.width/2, 60);
        panel.addChild(title);
        resizeLabelToFitText(title, panel.width-60);

        const description = new PIXI.BitmapText(locale('ui_splash_delete_confirm_description'), {
            fontName: "Alghera Pro",
            fontSize: 30,
            align: "left",
            tint: 0x702311,
            maxWidth: panel.width-60
        });
        description.position.set(30, 130);
        panel.addChild(description);

        panel.height = Math.max(panel.height, description.y + description.height + panel.bottomHeight);

        const hidePanel = (callback) => {
            this._tweens.push(
                gsap.to(panel, 0.3, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                    if (callback) {
                        callback();
                    }
                }}),
                gsap.to(this._fill, 0.2, {alpha:0, ease:Sine.easeIn, onComplete:() => {
                    this.removeChild(this._fill);
                }})
            );
        }

        const crossButton = P3.Button.create(
            texture("btn_action_medium_out"),
            null,
            null,
            texture("btn_icon_medium_cross")
        );
        this.signalListeners.push(
            crossButton.signals.click.add(() => {
                hidePanel();
            }, this)
        );
        crossButton.x = (panel.width/2) - 150;
        crossButton.y = panel.height;
        panel.addChild(crossButton);

        const tickButton = P3.Button.create(
            texture("btn_action_medium_out"),
            null,
            null,
            texture("btn_icon_medium_tick")
        );
        this.signalListeners.push(
            tickButton.signals.click.add(() => {
                common.saveData.createEmptySlot(slot.id, true);
                slot.statsHolder.visible = false;
                slot.deleteButton.visible = false;
                slot.playButton.new = true;
                hidePanel();
            }, this)
        );
        tickButton.x = (panel.width/2) + 150;
        tickButton.y = panel.height;
        panel.addChild(tickButton);

        this._tweens.push(
            gsap.to(panel, 0.3, {y:(common.STAGE_HEIGHT / 2) - (panel.height/2), ease:Expo.easeOut}),
            gsap.to(this._fill, 0.2, {alpha:0.3, ease:Sine.easeIn})
        );
    }

    resizeFill(){
        if (this._fill) {
            this._fill.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
            this._fill.width = P3.View.width;
            this._fill.height = P3.View.height;
        }
    }

    _getTotalNumberOfQuests() {
        let total = 0;
        for (let i in definitions.NPC_ID) {
            console.log(definitions.NPC_ID[i]);
            let data;
            try {
                data = json(definitions.NPC_ID[i]);
            } catch(err) {
                continue;
            }
            if (data && data.character && data.character.quests && data.quests) {

                if (data.character.location) {
                    try {
                        if(json(data.character.location).metadata.phase > settings.PHASE)
                            continue;
                    } catch(e) {

                    }
                }

                for (let j in data.character.quests) {
                    let quest = data.quests[data.character.quests[j]];
                    if (quest &&
                        !(quest.phase > settings.PHASE) &&
                        !QuestFactory.isMinigame(quest.type) &&
                        !QuestFactory.isBossFight(quest.type)) {
                        total++;
                        console.log(' > ' + data.character.quests[j]);
                    }
                }
            }
        }
        return total;
    }

    _placeIvandoe(slot) {
        this._ivandoe.x = this._slotHolder.x + this._slots[slot].x + 150;
        this._ivandoe.y = (common.STAGE_HEIGHT / 2) + 200;
        this._ivandoe.slot = slot;
        this._ivandoe.scale.x = this._ivandoe.scale.x * (Math.random() > 0.5 ? -1 : 1);
        if (Math.random() > 0.5) {
            this._ivandoe.state.setAnimation(0, 'body_idle_0' + Math.floor(Math.random() * 3), true);
        }

        this._tweens.push(
            gsap.to(this._ivandoe, 0.4, {y:(common.STAGE_HEIGHT / 2) - 40, ease:Expo.easeOut})
        );
    }

    _hideIvandoe(onComplete) {
        this._tweens.push(
            gsap.to(this._ivandoe, 0.3, {y:(common.STAGE_HEIGHT / 2) + 200, ease:Sine.easeOut, onComplete:() => {
                if (onComplete)
                    onComplete();
            }})
        );
    }
}